export const environment = {
  production: true,
  env: "production",
  basePath: "AppAngular/config/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts